import React, { useState } from "react";
import { Tabs } from "antd";
import CollapsibleCardHeader from "../../../../../components/atoms/cardHeader/collapsibleCardHeader";
import TinyEditor from "../../../../../components/atoms/formFields/tinyEditor";
import { useDispatch, useSelector } from "react-redux";
import { getDosageThunk } from "../../../../../store/thunks/InventoryThunk";

const TargetAnimalsDetail = ({ detail, productId }) => {
  const { data: animalDosage } = useSelector((state) => state?.getDosage || {});
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(null);

  const items = [
    {
      key: "1",
      label: <span>English</span>,
      children: (
        <TinyEditor disabled={true} value={animalDosage?.dosage?.en || ""} />
      ),
    },
    {
      key: "2",
      label: <span>Hindi</span>,
      children: (
        <TinyEditor disabled={true} value={animalDosage?.dosage?.hn || ""} />
      ),
    },
    {
      key: "3",
      label: <span>Punjabi</span>,
      children: (
        <TinyEditor disabled={true} value={animalDosage?.dosage?.pb || ""} />
      ),
    },
  ];

  return (
    <div className="card">
      <CollapsibleCardHeader
        name={"Target Animals"}
        id={"animals"}
        target={"collapse"}
      />

      <div id="collapse" className="collapse" data-parent="#animals">
        <div className="card-body">
          <div id="target_crops">
            <label className="font-weight-bolder font-size-lg mb-3 d-block h5">
              Selected Target Animals
            </label>
          </div>
          <div className="separator separator-solid my-5"></div>
          <div className="custom-radio-button-black">
            {detail?.targetAnimals?.map((animals, index) => {
              const isActive = selected === animals?.id;

              return (
                <React.Fragment key={animals?.id || index}>
                  <label
                    key={index.toString()}
                    className={`status ${isActive ? "active" : ""}`}
                    data-toggle="modal"
                    data-target="#annual_modal"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelected(animals?.id);
                      dispatch(
                        getDosageThunk({
                          animalDosageRequest: {
                            productId: productId,
                            tagId: animals?.id,
                          },
                        })
                      );
                    }}
                  >
                    <input type="radio" name="radio" />
                    <div className="box">
                      <span>{animals?.name?.en}</span>
                    </div>
                  </label>
                </React.Fragment>
              );
            })}
          </div>
          {animalDosage ? <Tabs defaultActiveKey="1" items={items} /> : ""}
        </div>
      </div>
    </div>
  );
};

export default TargetAnimalsDetail;
